import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { Back } from "gsap";
import lottie from "lottie-web";
gsap.registerPlugin(ScrollTrigger);

const select = document.querySelector('.bottom-bar');
const fork = select.querySelector('.bottom-bar__fork');
const forkAnimation = fork.querySelector('figure');
const tl = gsap.timeline({
    paused: true
});

tl.to(select, {
    y: '0%',
    duration: 0.3,
    ease: Back.easeOut,
})

const lottieFork = () => {
    return lottie.loadAnimation({
        container: forkAnimation,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: fork.dataset.src
    });
}

export const initFork = () => {
    if (forkAnimation.childNodes.length == 0) {
        let animation = lottieFork();
        gsap.matchMedia().add(
            "(min-width: 900px)", () => {
                fork.addEventListener('mouseenter', () => {
                    animation.play();
                })
                animation.addEventListener('complete', () => {
                    animation.goToAndStop(0);
                })
            }
        )
    };
}

export const introFork = () => {
    window.addEventListener('scroll', () => {
        const pageName = document.querySelector('.theme-main').dataset.barbaNamespace;
        if (pageName == 'index') {
            if (window.scrollY >= parseInt(0.8 * window.innerHeight)) {
                tl.play();
            } else {
                tl.reverse();
            }
        }
    })
}

export const setFork = () => {
    tl.reverse();
    setTimeout(() => {
        tl.play();
    }, 1500);
}
